const InternalErrorTemplate = (props) => {
  const { statusCode } = { ...props };

  return (
    <>
      An error occurred on client
    </>
  );
};

export default InternalErrorTemplate;
